/**
 * @generated SignedSource<<9252b39f5e2d950287dfe5db050fdede>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type postiesPrimaryContentItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink" | "helpersHasPostiesQuiz" | "hooksContentItemProvidersContent">;
  readonly " $fragmentType": "postiesPrimaryContentItemContent";
};
export type postiesPrimaryContentItemContent$key = {
  readonly " $data"?: postiesPrimaryContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"postiesPrimaryContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "postiesPrimaryContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "withSize1200x800",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withSize540x360",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "contentCoverImageContent"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "withHeadline",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "hooksContentItemProvidersContent"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersHasPostiesQuiz",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SectionSegment",
              "kind": "LinkedField",
              "name": "sections",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Section",
                  "kind": "LinkedField",
                  "name": "value",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "14a110516605d7fee7fc9589ab1394ca";

export default node;
